/* 
-----------------------------------------------------------------------------
| DATE PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics.
*/
import { FC } from "react";
import { DateSelection } from "../components/DateSelection";

const params = new URLSearchParams(window.location.search)
const from = params.get('calendar')
const at = params.get('at') ?? from
const value = params.get('value') ?? undefined
const monthsQty = parseInt(params.get('months-qty') ?? '1', 10)
const specialDates = (params.get('special-dates') ?? '').split(',')
const showLegend = params.has("show-legend")
const showTitle = params.has("show-title")

export const CalendarWidget: FC = () => {
   return (
      <main id="date-selection-page" className={`page-container calendar-widget ${showTitle ? "show-title" : ""}`} role="application">
         <DateSelection
            asCalendarWidget
            at={at}
            from={from}
            value={value}
            displayedMonthsQty={monthsQty}
            specialDates={specialDates}
            showLegend={showLegend}
         />
      </main>
   )
}